import { z } from "zod"

export const cfCommentStatusSchema = z.enum([
    "default",
    "not_listed_location",
    "brightness_alert",
    "beenhere",
    "dangerous",
])

export const colorFinderFrameCommentContextSchema = z.object({
    target: z.literal("cf-frame"),
    frame: z.number(),
    status: cfCommentStatusSchema,
})

export const colorFinderCommentReplyContextSchema = z.object({
    target: z.literal("cf-comment"),
})

export type CFCommentStatus = z.infer<typeof cfCommentStatusSchema>
export type ColorFinderFrameCommentContext = z.infer<typeof colorFinderFrameCommentContextSchema>
export type ColorFinderCommentReplyContext = z.infer<typeof colorFinderCommentReplyContextSchema>
